(function (angular) {
    'use strict';

    angular.module('profiles')

        /**
         *
         */
        .factory('messageHistoryService',
            ['$http', '$q', 'portalConfig',
                function ($http, $q, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    //urlBase = "http://localhost:8002";
                    var fac = {
                        getHistory: getHistory,
                        getSingleMessage: getSingleMessage
                    };

                    return fac;

                    function getHistory(apiSpaceId, profileId, fromQueryParameter, limitQueryParameter, async) {
                        return $http.get(urlBase + '/apispaces/' + apiSpaceId + '/profiles/' + profileId + '/messages?from=' + fromQueryParameter + '&limit=' + limitQueryParameter, { async: async })
                            .then(getHistoryComplete)
                            .catch(getHistoryFailed);

                        function getHistoryComplete(response) {
                            return response.data;
                        }

                        function getHistoryFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                    function getSingleMessage(apiSpaceId, messageId) {
                        return $http.get(urlBase + '/apispaces/' + apiSpaceId + '/messages/' + messageId)
                            .then(getSingleMessageComplete)
                            .catch(getSingleMessageFailed);

                        function getSingleMessageComplete(response) {
                            return response.data;
                        }

                        function getSingleMessageFailed(error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        }
                    }
                }]);
})(window.angular);